<template>
  <el-row>
    <el-row :gutter="20">
      <el-col :span="12"
              :xs="24">
        <el-card shadow="none">
          <span slot="header">
            <el-input placeholder="输入关键字进行过滤"
                      v-model="filterLeftText">
            </el-input>
          </span>
          <el-tree highlight-current
                   default-expand-all
                   class="room-tree"
                   ref="leftRoomTree"
                   node-key="id"
                   :expand-on-click-node="false"
                   :current-node-key="currentKey"
                   :data="tabList"
                   :props="defaultProps"
                   @node-click="params => handleNodeClick(params, 'left')">
          </el-tree>
          <el-divider></el-divider>
        </el-card>
      </el-col>
      <el-col :span="12"
              :xs="24">
        <el-card shadow="none">
          <span slot="header">
            <el-input placeholder="输入关键字进行过滤"
                      v-model="filterRightText">
            </el-input>
          </span>
          <el-tree highlight-current
                   default-expand-all
                   class="room-tree"
                   ref="rightRoomTree"
                   node-key="id"
                   :expand-on-click-node="false"
                   :current-node-key="currentKey"
                   :data="tabList"
                   :props="defaultProps"
                   @node-click="params => handleNodeClick(params, 'right')">
          </el-tree>
          <el-divider></el-divider>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-15 change-main"
            :gutter="10">
      <el-col :span="10"
              :xs="24">
        <el-card shadow="none">
          <el-checkbox-group v-model="leftCheckArr">
            <el-checkbox v-for="(item, index) in leftCheckData"
                         :key="index"
                         :label="item.id">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-card>
      </el-col>
      <el-col class="alignCenter"
              :span="4"
              :xs="24">
        <el-button type="primary"
                   :disabled="!rightCheckArr.length"
                   icon="el-icon-arrow-left"></el-button>
        <el-button type="primary"
                   :disabled="!leftCheckArr.length"
                   icon="el-icon-arrow-right"></el-button>
      </el-col>
      <el-col :span="10"
              :xs="24">
        <el-card shadow="none">
          <el-checkbox-group v-model="rightCheckArr">
            <el-checkbox v-for="(item, index) in rightCheckData"
                         :key="index"
                         :label="item.id">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      currentKey: 1,
      filterLeftText: '',
      filterRightText: '',
      leftCheckArr: [],
      rightCheckArr: [],
      defaultProps: {
        label: 'label',
        children: 'children'
      },
      tabList: [
        {
          id: 1,
          label: '人民大学',
          children: [
            {
              id: 2,
              label: '宿舍楼',
              children: [
                {
                  id: 21,
                  label: '静园'
                },
                {
                  id: 22,
                  label: '宜园'
                }
              ]
            },
            {
              id: 3,
              label: '图书馆',
              children: []
            },
            {
              id: 4,
              label: '教研楼',
              children: [
                {
                  id: 41,
                  label: '教学楼',
                  children: []
                },
                {
                  id: 42,
                  label: '科研楼',
                  children: []
                }
              ]
            }
          ]
        }
      ],
      leftCheckData: [],
      rightCheckData: []
    }
  },
  watch: {
    filterLeftText(val) {
      this.$refs.leftRoomTree.filter(val)
    },
    filterRightText(val) {
      this.$refs.rightRoomTree.filter(val)
    }
  },
  methods: {
    handleNodeClick(data, type) {
      console.log(data)
      if (type === 'left') {
        this.leftCheckData = data.children
      } else {
        this.rightCheckData = data.children
      }
    }
  }
}
</script>

<style lang="less" scoped>
.change-main {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>
